export const CAROUSEL_SLIDE_STEP = 2;
